module.exports = require("@seddi/mesh");